import { render, staticRenderFns } from "./SummaryFleetStatus.vue?vue&type=template&id=5527c6c2"
import script from "./SummaryFleetStatus.vue?vue&type=script&lang=js"
export * from "./SummaryFleetStatus.vue?vue&type=script&lang=js"
import style0 from "./SummaryFleetStatus.vue?vue&type=style&index=0&id=5527c6c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports